<template>
  <div class="relative">
    <i
      v-if="daysLeft"
      v-html="$icons.alert_sm"
      class="text-ontick-yellow-700 absolute -top-3"
      :class="compressed && plan.includes('MAX_PLUS') ? '-right-1' : '-right-3'"
      :content="`Expira em ${daysLeft} dias`"
      v-tippy="{ arrow: true, theme: 'yellow', boundary: 'viewport' }"
    ></i>
    <div
      :class="planData.style"
      :content="planData.tooltip"
      v-tippy="{ arrow: true, theme: 'green', boundary: 'viewport' }"
    >
      <span :class="planData.textStyle">
        {{ planData.label }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    plan: {
      type: String,
    },
    daysLeft: {
      type: Number,
    },
    compressed: {
      type: Boolean,
    },
    darkBg: {
      type: Boolean,
    },
  },
  computed: {
    planData() {
      switch (this.plan?.split(" ")[0]) {
        case "ADMIN":
          return {
            label: "Admin",
            style: "free-plan",
            textStyle: this.darkBg ? "text-gray-200" : "",
            tooltip: "Plano ADMIN",
          };
        case "TRIAL":
          return {
            label: "Trial",
            style: "free-plan",
            textStyle: this.darkBg ? "text-gray-200" : "",
            tooltip: "Plano TRIAL",
          };
        default:
          return {
            label: "Basic",
            style: "basic-styles bg-ontick-steel-400",
            tooltip: "Plano BASIC",
          };
        // case "PRO":
        //   return {
        //     label: "Basic",
        //     style: "basic-styles bg-ontick-steel-400",
        //     tooltip: "Plano BASIC",
        //   };
        // case "MAX":
        //   return {
        //     label: "Basic",
        //     style: "basic-styles bg-ontick-steel-400",
        //     tooltip: "Plano BASIC",
        //   };
        // case "MAX_PLUS":
        //   return {
        //     label: "Basic",
        //     style: "basic-styles bg-ontick-steel-400",
        //     tooltip: "Plano BASIC",
        //   };
        // case "BETA":
        //   return {
        //     label: "Basic",
        //     style: "basic-styles bg-ontick-steel-400",
        //     tooltip: "Plano BASIC",
        //   };
        // case "FREE":
        //   return {
        //     label: "Basic",
        //     style: "basic-styles bg-ontick-steel-400",
        //     tooltip: "Plano BASIC",
        //   };
        // default:
        //   return "TRIAL";
      }
    },
  },
};
</script>

<style scoped>
.basic-styles {
  @apply rounded px-1 py-0.5 text-xs font-normal uppercase text-gray-200;
}
.free-plan {
  @apply text-ontick-carbon-900 bg-transparent px-1 text-xs font-bold uppercase dark:text-gray-200;
}
</style>
